import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PagerService} from "../../services/pager.service";
import {Subject} from "rxjs/Subject";

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent implements OnInit, OnChanges{

  @Input() itemCount: number;
  @Input() pageSize: number = 25;
  @Input("page") pageSubject: Subject<number>;
  pager: any = {};

  constructor(private pagerService: PagerService) { }

  ngOnInit() {
    this.pageSubject.subscribe(page => {
      this.pager = this.pagerService.getPager(this.itemCount, page, this.pageSize);
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pager = this.pagerService.getPager(this.itemCount, this.pager.currentPage, this.pageSize);
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.itemCount, page, this.pageSize);

    this.pageSubject.next(page);
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/paginator/paginator.component.ts